import { Globe, Bell, User, Menu, X, LogOut, ShoppingCart } from "lucide-react";
import { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { getUserProfile } from "../services/api";
import { useTranslation } from 'react-i18next';
import { ChevronDown, ChevronUp } from 'lucide-react';
import i18n from 'i18next';
import { useMediaQuery, Button, } from "@mui/material";
import { usePTagForm } from "../contexts/PTagFormContext";
import NotifyContainer from "../pages/NotifyContainer";
import tokenManager from "../services/tokenManager";

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [showTranslationModal, setshowTranslationModal] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState('zh');
  const [showShopItems, setShowShopItems] = useState(false);
  const [showShopDropdown, setShowShopDropdown] = useState(false);
  const shopDropdownTimer = useRef(null);
  const { formsAdded, orderConfirmed, removeAllForms } = usePTagForm();
  const [user, setUser] = useState(null);
  const [admin, setAdmin] = useState(null);
  const [unreadNotificationCount, setUnreadNotificationCount] = useState(0);
  const { t } = useTranslation();
  const navigate = useNavigate();
  useEffect(() => {
    const token = Cookies.get("token");
    if (token) {
      setUser(true);
    } else {
      setUser(false);
    }
  }, []);

  // Get notification count from cookies
  useEffect(() => {
    const updateNotificationCount = () => {
      const notificationsCookie = Cookies.get("notifications");
      if (notificationsCookie) {
        try {
          const count = JSON.parse(notificationsCookie);
          setUnreadNotificationCount(count);
        } catch (error) {
          console.error("Error parsing notifications cookie:", error);
          setUnreadNotificationCount(0);
        }
      } else {
        setUnreadNotificationCount(0);
      }
    };

    // Update on mount
    updateNotificationCount();

    // Check for changes periodically (optional)
    const interval = setInterval(updateNotificationCount, 1000);

    return () => clearInterval(interval);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const getUserId = () => {
    const id = Cookies.get("id");
    return id;
  };

  const getUserRole = () => {
    const role = Cookies.get("role");
    return role;
  };



  // Fetch user role
  useEffect(() => {
    const token = Cookies.get("token");
    const role = getUserRole();
    if (role === 'admin' && token) {
      setAdmin(true);
    } else {
      setAdmin(false);
    }
  }, []);

  // Sync selectedLanguage with i18n language
  useEffect(() => {
    const currentLanguage = i18n.language;
    setSelectedLanguage(currentLanguage);
  }, []);

  const handleNavClick = () => {
    if (orderConfirmed) {
      removeAllForms();
    }
  };

  const handleShopMouseEnter = () => {
    if (shopDropdownTimer.current) {
      clearTimeout(shopDropdownTimer.current);
    }
    setShowShopDropdown(true);
  };

  const handleShopMouseLeave = () => {
    setShowShopDropdown(false);
  };

  const handleLogout = () => {
    // Clear tokens from memory (primary storage)
    tokenManager.clear();
    
    // Clear cookies (backward compatibility)
    Cookies.remove("token");
    Cookies.remove("id");
    Cookies.remove("role");
    
    // Update UI state
    setUser(false);
    setShowLogoutModal(false);
    
    // Redirect to login
    navigate("/login");
  };

  const isMobile = useMediaQuery("(max-width:768px)");

  return (
    <header
      className="bg-white border-b border-gray-200 py-3 md:py-0 fixed top-0 left-0 right-0 z-50 shadow-sm"
    >
      <div style={{ display: 'flex', justifyContent: "space-between", alignItems: 'center', padding: isMobile ? '0 16px' : '0 80px', }}>
        <Link to="/" onClick={handleNavClick} className="text-2xl md:text-3xl font-bold ">
          PTag
        </Link>

        <div className="hidden md:flex">
          {user && (
            <Link
              to="/pet-management"
              onClick={handleNavClick}
              className="text-sm lg:text-base hover:text-gray-500 hover:bg-gray-100 hover:shadow-md hover:border hover:border-gray-300 border border-transparent rounded-md transition-all duration-200 p-6 relative group overflow-hidden"
              style={{ fontFamily: 'Helvetica, sans-serif', fontWeight: '400' }}
            >
              <img
                src="/icons/head-manage.gif"
                alt="Management"
                className="absolute left-1/2 transform -translate-x-1/2 opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                style={{
                  width: "50px",
                  height: "auto",
                  mixBlendMode: "multiply",
                  top: "-30px",
                }}
              />
              {t('PetManagementHeader')}
            </Link>
          )}
          <Link
            to="/landing"
            onClick={handleNavClick}
            className="text-sm lg:text-base hover:text-gray-500 hover:bg-gray-100 hover:shadow-md hover:border hover:border-gray-300 border border-transparent rounded-md transition-all duration-200 p-6 relative group overflow-hidden"
            style={{ fontFamily: 'Helvetica, sans-serif', fontWeight: '400' }}
          >
            <img
              src="/icons/head-track.gif"
              alt="Track"
              className="absolute left-1/2 transform -translate-x-1/2 opacity-0 group-hover:opacity-100 transition-opacity duration-200"
              style={{
                width: "40px",
                height: "auto",
                mixBlendMode: "multiply",
                top: "-20px",
              }}
            />
            {t('Track')}
          </Link>
          <div
            className="relative"
            onMouseEnter={handleShopMouseEnter}
            onMouseLeave={handleShopMouseLeave}
          >
            <button
              onClick={handleNavClick}
              className="text-sm lg:text-base hover:text-gray-500 hover:bg-gray-100 hover:shadow-md hover:border hover:border-gray-300 border border-transparent rounded-md transition-all duration-200 p-6 relative group overflow-hidden cursor-pointer"
              style={{ fontFamily: 'Helvetica, sans-serif', fontWeight: '400' }}
            >
              <img
                src="/icons/head-shop.gif"
                alt="PTag"
                className="absolute left-1/2 transform -translate-x-1/2 opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                style={{
                  width: "40px",
                  height: "auto",
                  mixBlendMode: "multiply",
                  top: "-20px",
                  rotate: "180deg",
                }}
              />
              {t('Shop')}
            </button>
            
            {/* Shop Dropdown */}
            <div
              className={`absolute left-1/2 transform -translate-x-1/2 transition-all duration-300 ease-out ${
                showShopDropdown 
                  ? 'opacity-100 translate-y-0 pointer-events-auto' 
                  : 'opacity-0 -translate-y-4 pointer-events-none'
              }`}
              style={{
                top: '100%',
                paddingTop: '8px',
                zIndex: 100,
              }}
            >
              <div className="bg-white rounded-lg shadow-xl border border-gray-200 p-4 flex gap-6">
                {/* PTag Option */}
                <Link
                  to="/ptag"
                  onClick={() => { handleNavClick(); setShowShopDropdown(false); }}
                  className="flex flex-col items-center gap-2 group transition-all duration-200"
                  style={{ width: '120px', cursor: 'pointer' }}
                >
                  <div className="relative overflow-hidden rounded-full transition-all duration-300 group-hover:scale-110" style={{ cursor: 'pointer' }}>
                    <img
                      src="/icons/ptag-2.png"
                      alt="PTag"
                      className="w-24 h-24 object-cover rounded-full border-2 border-gray-200 group-hover:border-yellow-400 transition-all duration-300"
                      style={{ cursor: 'pointer' }}
                    />
                  </div>
                  <span className="text-sm font-medium text-gray-700 group-hover:text-yellow-600 transition-colors duration-200" style={{ cursor: 'pointer' }}>
                    PTag
                  </span>
                </Link>

                {/* PTag Air Option */}
                <Link
                  to="/ptag-air"
                  onClick={() => { handleNavClick(); setShowShopDropdown(false); }}
                  className="flex flex-col items-center gap-2 group transition-all duration-200"
                  style={{ width: '120px', cursor: 'pointer' }}
                >
                  <div className="relative overflow-hidden rounded-full transition-all duration-300 group-hover:scale-110" style={{ cursor: 'pointer' }}>
                    <img
                      src="/icons/ptagair-2.png"
                      alt="PTag Air"
                      className="w-24 h-24 object-cover rounded-full border-2 border-gray-200 group-hover:border-yellow-400 transition-all duration-300"
                      style={{ cursor: 'pointer' }}
                    />
                  </div>
                  <span className="text-sm font-medium text-gray-700 group-hover:text-yellow-600 transition-colors duration-200" style={{ cursor: 'pointer' }}>
                    PTag Air
                  </span>
                </Link>
              </div>
            </div>
          </div>

          <Link
            to="/all_lost_pets"
            onClick={handleNavClick}
            className="text-sm lg:text-base hover:text-gray-500 hover:bg-gray-100 hover:shadow-md hover:border hover:border-gray-300 border border-transparent rounded-md transition-all duration-200 p-6 relative group overflow-hidden"
            style={{ fontFamily: 'Helvetica, sans-serif', fontWeight: '400' }}
          >
            <img
              src="/icons/head-registry.gif"
              alt="PTag"
              className="absolute left-1/2 transform -translate-x-1/2 opacity-0 group-hover:opacity-100 transition-opacity duration-200"
              style={{
                width: "40px",
                height: "auto",
                mixBlendMode: "multiply",
                top: "-20px",
              }}
            />
            {t('Registry')}
          </Link>
          {admin && (
            <Link
              to="/check_tag"
              onClick={handleNavClick}
              className="text-sm lg:text-base hover:text-gray-500 hover:bg-gray-100 hover:shadow-md hover:border hover:border-gray-300 border border-transparent rounded-md transition-all duration-200 p-6 relative group overflow-hidden"
              style={{ fontFamily: 'Helvetica, sans-serif', fontWeight: '400' }}
            >
              <img
                src="/icons/head-check.gif"
                alt="PTag"
                className="absolute left-1/2 transform -translate-x-1/2 opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                style={{
                  width: "40px",
                  height: "auto",
                  mixBlendMode: "multiply",
                  top: "-19px",
                }}
              />
              {t('Check')}
            </Link>
          )}
        </div>

        <div className="hidden md:flex space-x-2 lg:space-x-4 relative">
          <button
            className="p-1 hover:bg-gray-100 rounded-md transition-colors duration-200 relative"
          >
            <Link to="/shopping_cart" onClick={handleNavClick}>
              <ShoppingCart className="h-5 w-5 md:h-6 md:w-6" strokeWidth={1.5} />
              {formsAdded > 0 && (
                <span
                  style={{
                    position: "absolute",
                    top: 2,
                    right: 2,
                    background: "#facc15",
                    color: "#000",
                    borderRadius: "9999px",
                    fontSize: "8px",
                    fontWeight: "bold",
                    width: "15px",
                    height: "15px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "1px solid #fff",
                    zIndex: 10,
                  }}
                >
                  {formsAdded}
                </span>
              )}
            </Link>
          </button>
          <button
            className="p-1 hover:bg-gray-100 rounded-md transition-colors duration-200 cursor-pointer relative"
            onClick={() => setshowTranslationModal(prev => !prev)}
          >
            <Globe className="h-5 w-5 md:h-6 md:w-6" strokeWidth={1.5} />
            {showTranslationModal && (
              <div id="languageMenu"
                onClick={(e) => e.stopPropagation()}
                style={{ position: "absolute", left: 0, top: 52, backgroundColor: "#FFF", border: "1px solid #D1D1D1", borderRadius: 5, display: 'flex', flexDirection: 'column', }}>
                <Button
                  sx={{
                    cursor: 'pointer',
                    color: 'black',
                    fontFamily: 'Helvetica, sans-serif',
                    fontWeight: 400,
                    minWidth: 0,
                    border: '1px solid transparent',
                    borderRadius: '6px',
                    '&:hover': {
                      backgroundColor: '#f3f4f6',
                      boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
                      border: '1px solid #d1d5db'
                    }
                  }}
                  onClick={(e) => { e.stopPropagation(); setSelectedLanguage('zh'); i18n.changeLanguage('zh'); setshowTranslationModal(false); }}>ZH</Button>
                <Button
                  sx={{
                    cursor: 'pointer',
                    color: 'black',
                    fontFamily: 'Helvetica, sans-serif',
                    fontWeight: 400,
                    minWidth: 0,
                    border: '1px solid transparent',
                    borderRadius: '6px',
                    '&:hover': {
                      backgroundColor: '#f3f4f6',
                      boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
                      border: '1px solid #d1d5db'
                    }
                  }}
                  onClick={(e) => { e.stopPropagation(); setSelectedLanguage('en'); i18n.changeLanguage('en'); setshowTranslationModal(false); }}>EN</Button>
              </div>
            )}
          </button>
          {user && (
            <button
              className="p-1 hover:bg-gray-100 rounded-md transition-colors duration-200 relative cursor-pointer"
              onClick={() => setOpen(true)}
            >
              <Bell className="h-5 w-5 md:h-6 md:w-6" strokeWidth={1.5} />
              {unreadNotificationCount > 0 && (
                <span
                  style={{
                    position: "absolute",
                    top: -2,
                    right: -2,
                    background: "#facc15",
                    color: "#000",
                    borderRadius: "9999px",
                    fontSize: "10px",
                    fontWeight: "bold",
                    minWidth: "18px",
                    height: "18px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "1px solid #fff",
                    padding: "0 4px",
                    zIndex: 10,
                  }}
                >
                  {unreadNotificationCount}
                </span>
              )}
            </button>
          )}
          <button className="p-1 hover:bg-gray-100 rounded-md transition-colors duration-200">
            {user ? (
              <Link to={`/account/${getUserId()}`}>
                <User className="h-5 w-5 md:h-6 md:w-6" strokeWidth={1.5} />
              </Link>
            ) : (
              <Link to="/login">
                <User className="h-5 w-5 md:h-6 md:w-6" strokeWidth={1.5} />
              </Link>
            )}
          </button>
          {user && (
            <button
              className="p-1 hover:bg-gray-100 rounded-md transition-colors duration-200 cursor-pointer"
              onClick={() => setShowLogoutModal(true)}
            >
              <LogOut className="h-5 w-5 md:h-6 md:w-6" strokeWidth={1.5} />
            </button>
          )}
        </div>

        {isMobile && (
          <div className="flex items-center gap-2">
            <button
              className="p-0 hover:bg-gray-100 rounded-md transition-colors duration-200 cursor-pointer relative my-2 flex items-center justify-center gap-1"
              onClick={() => setshowTranslationModal(prev => !prev)}
              style={{
                minWidth: 40,
                fontFamily: 'Oswald, sans-serif',
                fontWeight: 400,
                fontSize: '14px',
                border: '1px solid black',
              }}
            >
              {selectedLanguage === 'zh' ? 'ZH' : 'EN'}
              {showTranslationModal ? (
                <ChevronUp className="h-3 w-3" strokeWidth={2} />
              ) : (
                <ChevronDown className="h-3 w-3" strokeWidth={2} />
              )}

              {showTranslationModal && (
                <div id="languageMenu"
                  onClick={(e) => e.stopPropagation()}
                  style={{ position: "absolute", minWidth: 40, top: 22, backgroundColor: "#FFF", border: "1px solid #D1D1D1", borderRadius: 5, display: 'flex', flexDirection: 'column', zIndex: 100 }}>
                  <Button
                    sx={{
                      cursor: 'pointer',
                      color: 'black',
                      fontFamily: 'Oswald, sans-serif',
                      fontWeight: 400,
                      minWidth: 0,
                      border: '1px solid transparent',
                      borderRadius: '6px',
                      '&:hover': {
                        backgroundColor: '#f3f4f6',
                        boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
                        border: '1px solid #d1d5db'
                      }
                    }}
                    onClick={(e) => { e.stopPropagation(); setSelectedLanguage('zh'); i18n.changeLanguage('zh'); setshowTranslationModal(false); }}>ZH</Button>
                  <Button
                    sx={{
                      cursor: 'pointer',
                      color: 'black',
                      fontFamily: 'Oswald, sans-serif',
                      fontWeight: 400,
                      minWidth: 0,
                      border: '1px solid transparent',
                      borderRadius: '6px',
                      '&:hover': {
                        backgroundColor: '#f3f4f6',
                        boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
                        border: '1px solid #d1d5db'
                      }
                    }}
                    onClick={(e) => { e.stopPropagation(); setSelectedLanguage('en'); i18n.changeLanguage('en'); setshowTranslationModal(false); }}>EN</Button>
                </div>
              )}
            </button>
            <button
              className="md:hidden p-1 hover:bg-gray-100 rounded-md transition-colors duration-200"
              onClick={toggleMenu}
              aria-label={isMenuOpen ? "關閉選單" : "打開選單"}
            >
              <div style={{ position: 'relative', width: '24px', height: '24px' }}>
                <div
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    transition: 'transform 0.3s ease, opacity 0.3s ease',
                    transform: isMenuOpen ? 'rotate(90deg)' : 'rotate(0deg)',
                    opacity: isMenuOpen ? 0 : 1,
                  }}
                >
                  <Menu className="h-6 w-6" strokeWidth={1.5} />
                  {user && unreadNotificationCount > 0 && !open && (
                    <div
                      style={{
                        position: 'absolute',
                        top: -2,
                        right: -2,
                        width: '8px',
                        height: '8px',
                        background: '#facc15',
                        borderRadius: '9999px',
                        border: '1px solid #fff',
                        zIndex: 10,
                      }}
                    />
                  )}
                </div>
                <div
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    transition: 'transform 0.3s ease, opacity 0.3s ease',
                    transform: isMenuOpen ? 'rotate(0deg)' : 'rotate(-90deg)',
                    opacity: isMenuOpen ? 1 : 0,
                  }}
                >
                  <X className="h-6 w-6" strokeWidth={1.5} />
                </div>
              </div>
            </button>
          </div>

        )}
      </div>

      {/* 手機版彈出菜單 */}
      {isMenuOpen && (
        <>
          <div
            className="fixed bg-black/40 z-40"
            style={{ top: '70px', left: 0, right: 0, bottom: 0 }}
            onClick={() => setIsMenuOpen(false)}
          />
          <div className="md:hidden absolute top-full left-0 right-0 z-50 bg-white border-t border-gray-200 shadow-lg">
            <div className="container mx-auto px-4 py-4">
              <div className="flex flex-col space-y-4">
                {user && (
                  <Link
                    to="/pet-management"
                    className="text-base py-2 border-b border-gray-100 hover:text-blue-600 transition-colors duration-200"
                    onClick={() => { setIsMenuOpen(false); handleNavClick(); }}
                  >
                    {t('PetManagementFooter')}
                  </Link>
                )}

                <Link
                  to="/landing"
                  className="text-base py-2 border-b border-gray-100 hover:text-blue-600 transition-colors duration-200"
                  onClick={() => { setIsMenuOpen(false); handleNavClick(); }}
                >
                  {t('Track2')}
                </Link>

                <div className="py-2 border-b border-gray-100">
                  <button
                    onClick={() => setShowShopItems(!showShopItems)}
                    className="w-full flex items-center justify-between text-base hover:text-blue-600 transition-colors duration-200"
                    style={{ fontFamily: 'Helvetica, sans-serif', fontWeight: '400' }}
                  >
                    <span>{t('ShopItems')}</span>
                  
                  </button>
                  <div className="mt-2 ml-4 space-y-2">
                      <Link
                        to="/ptag"
                        className="flex items-center text-sm py-2 hover:text-blue-600 transition-colors duration-200 relative"
                        onClick={() => { setIsMenuOpen(false); handleNavClick(); }}
                        style={{ fontFamily: 'Helvetica, sans-serif', fontWeight: '400' }}
                      >
                        <div className="absolute left-0 top-0 bottom-0 flex items-center">
                          <div style={{
                            width: '2px',
                            height: '100%',
                            background: '#e5e7eb',
                            marginRight: '8px'
                          }}></div>
                          <div style={{
                            width: '12px',
                            height: '2px',
                            background: '#e5e7eb'
                          }}></div>
                        </div>
                        <span className="ml-6">PTag</span>
                      </Link>

                      <Link
                        to="/ptag-air"
                        className="flex items-center text-sm py-2 hover:text-blue-600 transition-colors duration-200 relative"
                        onClick={() => { setIsMenuOpen(false); handleNavClick(); }}
                        style={{ fontFamily: 'Helvetica, sans-serif', fontWeight: '400' }}
                      >
                        <div className="absolute left-0 top-0 bottom-0 flex items-center">
                          <div style={{
                            width: '2px',
                            height: '100%',
                            background: '#e5e7eb',
                            marginRight: '8px'
                          }}></div>
                          <div style={{
                            width: '12px',
                            height: '2px',
                            background: '#e5e7eb'
                          }}></div>
                        </div>
                        <span className="ml-6">PTag Air</span>
                      </Link>
                    </div>
                
                </div>
                
                <Link
                  to="/all_lost_pets"
                  onClick={() => { setIsMenuOpen(false); handleNavClick(); }}
                  className="text-base py-2 border-b border-gray-100 hover:text-blue-600 transition-colors duration-200"
                >
                  {t('Registry2')}
                </Link>
                {admin && (
                  <Link
                    to="/check_tag"
                    className="text-base py-2 border-b border-gray-100 hover:text-blue-600 transition-colors duration-200"
                    onClick={() => { setIsMenuOpen(false); handleNavClick(); }}
                  >
                    {t('Check2')}
                  </Link>
                )}

                <div style={{ display: "flex", justifyContent: user ? "space-between" : "space-around", pt: 4 }}>

                  <button
                    className="p-1 hover:bg-gray-100 rounded-md transition-colors duration-200 relative"
                  >
                    <Link to="/shopping_cart" onClick={handleNavClick}>
                      <ShoppingCart className="h-5 w-5 md:h-6 md:w-6" strokeWidth={1.5} />
                      {formsAdded > 0 && (
                        <span
                          style={{
                            position: "absolute",
                            top: 2,
                            right: 2,
                            background: "#facc15",
                            color: "#000",
                            borderRadius: "9999px",
                            fontSize: "8px",
                            fontWeight: "bold",
                            width: "15px",
                            height: "15px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            border: "1px solid #fff",
                            zIndex: 10,
                          }}
                        >
                          {formsAdded}
                        </span>
                      )}
                    </Link>
                  </button>

                  {/* {selectedLanguage === 'en' ? (
                  <Button
                    style={{ cursor: 'pointer', color: 'black' }}
                    onClick={(e) => {
                      e.stopPropagation();
                      setSelectedLanguage('zh');
                      i18n.changeLanguage('zh');
                    }}
                  >
                    繁中
                  </Button>
                ) : (
                  <Button
                    style={{ cursor: 'pointer', color: 'black' }}
                    onClick={(e) => {
                      e.stopPropagation();
                      setSelectedLanguage('en');
                      i18n.changeLanguage('en');
                    }}
                  >
                    ENG
                  </Button>
                )} */}

                  {user && (
                    <button
                      className="p-1 hover:bg-gray-100 rounded-md transition-colors duration-200 relative"
                      onClick={() => navigate("/notification")}
                    >
                      <Bell className="h-6 w-6" strokeWidth={1.5} />
                      {unreadNotificationCount > 0 && (
                        <span
                          style={{
                            position: "absolute",
                            top: -2,
                            right: -2,
                            background: "#facc15",
                            color: "#000",
                            borderRadius: "9999px",
                            fontSize: "10px",
                            fontWeight: "bold",
                            minWidth: "18px",
                            height: "18px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            border: "1px solid #fff",
                            padding: "0 4px",
                            zIndex: 10,
                          }}
                        >
                          {unreadNotificationCount}
                        </span>
                      )}
                    </button>
                  )}
                  <button className="p-1 hover:bg-gray-100 rounded-md transition-colors duration-200">
                    {user ? (
                      <Link to={`/account/${getUserId()}`}>
                        <User className="h-6 w-6" strokeWidth={1.5} />
                      </Link>
                    ) : (
                      <Link to="/login">
                        <User className="h-6 w-6" strokeWidth={1.5} />
                      </Link>
                    )}
                  </button>
                  {user && (
                    <button
                      className="p-1 hover:bg-gray-100 rounded-md transition-colors duration-200"
                      onClick={() => setShowLogoutModal(true)}
                    >
                      <LogOut className="h-6 w-6" strokeWidth={1.5} />
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {/* NotifyContainer Panel */}
      <NotifyContainer open={open} onClose={() => setOpen(false)} />

      {showLogoutModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
          <div className="bg-white rounded-lg shadow-lg p-8 max-w-xs w-full flex flex-col items-center">
            <div className="text-lg font-semibold mb-6">{t("logout")}</div>
            <div className="flex w-full gap-4">
              <button
                className="flex-1 py-2 rounded bg-gray-200 hover:bg-gray-300 text-gray-800 font-bold"
                onClick={() => setShowLogoutModal(false)}
              >
                {t("cancel")}
              </button>
              <button
                className="flex-1 py-2 rounded bg-yellow-400 hover:bg-yellow-500 text-black font-bold"
                onClick={handleLogout}
              >
                {t("logoutConfirm")}
              </button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}